export const numericString = /^[0-9]+$/;
